<template>
  <div class="modern-worker-history" :style="backgroundStyles">
    <!-- Header con controles de tema -->
    <div class="header-section">
      <div class="title-container">
        <h1 class="main-title">
          <i class="mdi mdi-account-clock"></i>
          Historial por Trabajador
        </h1>
        <div class="theme-controls">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="theme-btn" :style="{ color: currentTheme.primary }">
                <i class="mdi mdi-palette"></i>
              </v-btn>
            </template>
            <v-card class="theme-selector">
              <v-card-title class="pb-2">Personalizar Colores</v-card-title>
              <v-card-text>
                <div class="color-options">
                  <div v-for="theme in themeOptions" :key="theme.name" class="color-option"
                    :class="{ active: selectedTheme === theme.name }" @click="changeTheme(theme.name)">
                    <div class="color-preview">
                      <div class="color-dot" :style="{ backgroundColor: theme.primary }"></div>
                      <div class="color-dot" :style="{ backgroundColor: theme.secondary }"></div>
                      <div class="color-dot" :style="{ backgroundColor: theme.accent }"></div>
                    </div>
                    <span class="theme-name">{{ theme.displayName }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </div>
    </div>

    <!-- Tarjeta principal -->
    <v-card class="main-card" :style="cardStyles">
      <!-- Sección de búsqueda -->
      <div class="search-section"
        :style="{ background: `linear-gradient(135deg, ${currentTheme.primary}15, ${currentTheme.secondary}15)` }">
        <v-row align="center">
          <v-col cols="12" md="6">
            <div class="search-container">
              <s-toolbar-person ref="DNI" v-model="filter.PrsDocumentNumber" @returnPerson="returnPerson($event)"
                :autofocus="false" noEdit noCamera type="text" class="modern-input" />
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-chip v-if="person.NtpFullName" :color="currentTheme.primary" text-color="white" class="status-chip">
              <i class="mdi mdi-account-check mr-2"></i>
              Trabajador Seleccionado
            </v-chip>
          </v-col>
        </v-row>
      </div>

      <!-- Información del trabajador -->
      <div v-if="person.NtpFullName" class="worker-info-section">
        <div class="worker-header">
          <div class="worker-avatar">
            <i class="mdi mdi-account-circle" :style="{ color: currentTheme.primary }"></i>
          </div>
          <div class="worker-details">
            <h2 class="worker-name">{{ person.NtpFullName }}</h2>
            <p class="worker-subtitle">{{ person.PstName }} - {{ person.AreName }}</p>
            <p class="worker-subtitle">DNI : {{ person.PrsDocumentNumber }}</p>
            <p class="worker-subtitle">Fecha de Ingreso : {{ person.CtrAdmissionDate }}</p>
          </div>
        </div>

        <!-- Información en tarjetas -->
        <v-row class="info-cards">
          <!-- <v-col cols="12" sm="6" md="4">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-card-account-details" :style="{ color: currentTheme.primary }"></i>
              </div>
              <div class="info-content">
                <p class="info-label">DNI</p>
                <p class="info-value">{{ person.PrsDocumentNumber }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-calendar-clock" :style="{ color: currentTheme.secondary }"></i>
              </div>
              <div class="info-content">
                <p class="info-label">Fecha de Ingreso</p>
                <p class="info-value">{{ person.CtrAdmissionDate }}</p>
              </div>
            </div>
          </v-col> -->
          <v-col cols="12" sm="6" md="3">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-beach" :style="{ color: currentTheme.accent }"></i>
              </div>
              <div class="info-content">
                <p class="info-label">Días Correspondientes</p>
                <p class="info-value">{{ totalVctDays }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-calendar-check" :style="{ color: currentTheme.success }"></i>
              </div>
              <div class="info-content">
                <p class="info-label">Días Gozados</p>
                <p class="info-value">{{ totalVcdDays }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-cash-register" style="color: #FF9800;"></i>
              </div>
              <div class="info-content">
                <p class="info-label">Días Vendidos</p>
                <p class="info-value">{{ totalVctSoldDays }}</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <div class="info-card" :style="infoCardStyles">
              <div class="info-icon">
                <i class="mdi mdi-chart-donut" :style="{ color: currentTheme.warning }"></i>
              </div>
              <div class="info-content">
                <p class="info-label">Días Pendientes</p>
                <p class="info-value">{{ totalVctDays - totalVcdDays - totalVctSoldDays }}</p>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Progreso visual -->
        <div class="progress-section">
          <h3 class="progress-title">Progreso de Vacaciones</h3>
          <v-progress-linear :value="((totalVcdDays + totalVctSoldDays) / (totalVctDays || 1)) * 100" :color="currentTheme.primary" height="12"
            rounded class="progress-bar">
            <template v-slot:default="{ value }">
              <strong class="progress-text">{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>
        </div>
      </div>

      <!-- Tabla de datos -->
      <div v-if="items.length > 0" class="table-section">
        <div class="table-header">
          <h3 class="table-title">Detalle de Vacaciones</h3>
          <v-chip :color="currentTheme.info" text-color="white" small>
            {{items.filter(item => !item.__isGroup).length}} registros
          </v-chip>
        </div>

        <div class="modern-table-container">
          <v-data-table :headers="headers" item-key="VcdID" v-model="selected" @click:row="selectedCheckSlot($event)"
            :items="items" :items-per-page="-1" class="modern-table" :footer-props="{
              showCurrentPage: true,
              showFirstLastPage: true,
              itemsPerPageOptions: [-1],
            }">
            <template v-slot:item="{ item }">
              <!-- Fila de resumen -->
              <tr v-if="item.__isGroup" class="group-row" :style="groupRowStyles">
                <td colspan="2" class="group-cell">
                  <div class="group-content">
                    <i class="mdi mdi-calendar-range mr-2" :style="{ color: currentTheme.primary }"></i>
                    <strong>Periodo {{ item.VctPeriod }}</strong>
                  </div>
                </td>
                <td colspan="3" class="text-center group-cell" style="color: #9e9e9e;">
                  {{ item.VctObservation }}
                </td>
                <td class="text-center group-cell">
                  <v-chip :color="currentTheme.secondary" text-color="white" small>
                    {{ item.VctDays }} días
                  </v-chip>
                  <v-tooltip bottom v-if="item.VctAccumulatedDays > 0">
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" color="purple" text-color="white" small class="ml-1">
                        +{{ item.VctAccumulatedDays }}d acum.
                      </v-chip>
                    </template>
                    <span>Acumulado de periodo {{ item.VctAccumulatedFromPeriod || 'anterior' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.VctTransferredDays > 0">
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" color="grey darken-1" text-color="white" small class="ml-1">
                        {{ item.VctTransferredDays }}d traspasados
                      </v-chip>
                    </template>
                    <span>Transferido al periodo {{ item.VctAccumulatedToPeriod }}</span>
                  </v-tooltip>
                  <v-chip v-if="item.VctSoldDays > 0" color="amber darken-2" text-color="white" small class="ml-1">
                    {{ item.VctSoldDays }}d vend.
                  </v-chip>
                </td>
                <!-- <td class="group-cell"></td>
                <td class="group-cell"></td>
                <td class="group-cell"></td> -->
                <td class="text-center group-cell">
                  <v-chip :color="currentTheme.accent" text-color="white" small>
                    {{ item.VcdDays }} días
                  </v-chip>
                </td>
              </tr>

              <!-- Fila normal -->
              <tr v-else class="data-row" :class="{ selected: selected.includes(item) }">
                <td class="text-center">
                  <v-chip :color="currentTheme.primary" text-color="white" x-small>
                    {{ item.VcdID }}
                  </v-chip>
                </td>
                <td class="text-center">{{ item.VctPeriod }}</td>
                <td class="text-center">
                  <span class="days-badge corresponds">{{ item.VctDays }}</span>
                </td>
                <td class="text-center">
                  <v-chip v-if="item.NumBallot" color="grey" text-color="white" x-small>
                    {{ item.NumBallot }}
                  </v-chip>
                  <span v-else class="text-grey">-</span>
                </td>
                <td class="text-center">
                  <span class="date-display">{{ $fun.formatDateView(item.VcdDateInit) }}</span>
                </td>
                <td class="text-center">
                  <span class="date-display">{{ $fun.formatDateView(item.VcdDateEnd) }}</span>
                </td>
                <td class="text-center">
                  <span class="days-badge enjoyed">{{ item.VcdDays }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Estado vacío -->
      <div v-else-if="!person.NtpFullName" class="empty-state">
        <div class="empty-icon">
          <i class="mdi mdi-account-search" :style="{ color: currentTheme.primary }"></i>
        </div>
        <h3>Buscar Trabajador</h3>
        <p>Ingrese el DNI del trabajador para ver su historial de vacaciones</p>
      </div>
    </v-card>
  </div>
</template>

<script>
import HistoryWorkerService from '@/services/HumanResource/HistoryWorkerService';
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";

export default {
  components: {
    sToolbarPerson
  },
  data() {
    return {
      selected: [],
      items: [],
      filter: {
        PrsDocumentNumber: ""
      },
      person: {
        NtpFullName: "",
        PrsDocumentNumber: "",
        CtrAdmissionDate: "",
        AreName: "",
        PstName: "",
        VctDays: ""
      },
      headers: [
        { text: "ID", value: "VcdID", align: "center", width: 50, sortable: false },
        { text: "PERIODO", value: "VctPeriod", align: "center", width: 120, sortable: false },
        { text: "DÍAS CORRESPONDEN", value: "VctDays", width: 150, align: "center", sortable: false },
        { text: "N° PAPELETA", value: "NumBallot", align: "center", width: 120, sortable: false },
        { text: "FECHA INICIO", value: "VcdDateInit", width: 130, align: "center", sortable: false },
        { text: "FECHA FIN", value: "VcdDateEnd", width: 130, align: "center", sortable: false },
        { text: "DÍAS GOZADOS", value: "VcdDays", align: "center", width: 120, sortable: false },
      ],
      totalVctDays: 0,
      totalVcdDays: 0,
      totalVctSoldDays: 0,
      selectedTheme: 'blue',
      themeOptions: [
        {
          name: 'blue',
          displayName: 'Azul Corporativo',
          primary: '#1976D2',
          secondary: '#42A5F5',
          accent: '#FFC107',
          success: '#4CAF50',
          warning: '#FF9800',
          error: '#F44336',
          info: '#2196F3'
        },
        {
          name: 'purple',
          displayName: 'Púrpura Moderno',
          primary: '#7B1FA2',
          secondary: '#AB47BC',
          accent: '#E91E63',
          success: '#4CAF50',
          warning: '#FF9800',
          error: '#F44336',
          info: '#9C27B0'
        },
        {
          name: 'green',
          displayName: 'Verde Natural',
          primary: '#388E3C',
          secondary: '#66BB6A',
          accent: '#FF5722',
          success: '#4CAF50',
          warning: '#FF9800',
          error: '#F44336',
          info: '#009688'
        },
        {
          name: 'orange',
          displayName: 'Naranja Energético',
          primary: '#F57C00',
          secondary: '#FFB74D',
          accent: '#E91E63',
          success: '#4CAF50',
          warning: '#FF9800',
          error: '#F44336',
          info: '#FF9800'
        },
        {
          name: 'dark',
          displayName: 'Oscuro Elegante',
          primary: '#424242',
          secondary: '#616161',
          accent: '#00BCD4',
          success: '#4CAF50',
          warning: '#FF9800',
          error: '#F44336',
          info: '#607D8B'
        },
        {
          name: 'pinkSoft',
          displayName: 'Rosado Pastel',
          primary: '#F48FB1',
          secondary: '#FCE4EC',
          accent: '#EC407A',
          success: '#81C784',
          warning: '#FFD54F',
          error: '#E57373',
          info: '#F06292'
        }
      ]
    }
  },
  computed: {
    currentTheme() {
      return this.themeOptions.find(theme => theme.name === this.selectedTheme);
    },
    cardStyles() {
      return {
        boxShadow: `0 8px 32px ${this.currentTheme.primary}20`,
        border: `1px solid ${this.currentTheme.primary}10`
      };
    },
    infoCardStyles() {
      return {
        background: `linear-gradient(135deg, ${this.currentTheme.primary}08, ${this.currentTheme.secondary}08)`,
        border: `1px solid ${this.currentTheme.primary}20`
      };
    },
    groupRowStyles() {
      return {
        background: `linear-gradient(135deg, ${this.currentTheme.primary}15, ${this.currentTheme.secondary}10)`,
        borderLeft: `4px solid ${this.currentTheme.primary}`
      };
    },
    backgroundStyles() {
      return {
        background: `linear-gradient(135deg, #f5f7fa 0%, ${this.currentTheme.secondary}40 100%)`
      };
    }
  },
  mounted() {
    this.loadTheme();
  },
  methods: {
    loadTheme() {
      const savedTheme = localStorage.getItem('workerHistoryTheme');
      if (savedTheme && this.themeOptions.find(t => t.name === savedTheme)) {
        this.selectedTheme = savedTheme;
      }
    },
    changeTheme(themeName) {
      this.selectedTheme = themeName;
      localStorage.setItem('workerHistoryTheme', themeName);
    },
    save(item) {
      console.log(item);
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },
    returnPerson(item) {
      this.person = {};
      if (item != null) {
        this.person = { ...item };
        console.log(this.person);
        this.filter.PrsDocumentNumber = this.person.PrsDocumentNumber;
        this.person.CtrAdmissionDate = this.$fun.formatDateView(this.person.CtrAdmissionDate);
        this.pagination();
      } else {
        this.items = [];
      }
    },
    pagination() {
      HistoryWorkerService.pagination(this.filter, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.items = this.groupAndSummarize(r.data);
        }
      });
    },
    groupAndSummarize(items) {
      const grouped = {};
      const result = [];

      this.totalVctDays = 0;
      this.totalVcdDays = 0;
      this.totalVctSoldDays = 0;

      // Paso 1: Inicializar los periodos y determinar el Derecho Real, Días Vendidos y Días Acumulados
      items.forEach(item => {
        const period = item.VctPeriod;
        if (!grouped[period]) {
          grouped[period] = {
            rows: [],
            VctDays: 0,
            VcdDays: 0,
            VctSoldDays: item.VctSoldDays || 0,
            VctAccumulatedDays: item.VctAccumulatedDays || 0,
            VctTransferredDays: item.VctTransferredDays || 0,
            VctIsAccumulated: item.VctIsAccumulated || false,
            VctAccumulatedFromPeriod: item.VctAccumulatedFromPeriod,
            VctAccumulatedToPeriod: item.VctAccumulatedToPeriod,
            VctObservation: item.VctObservation
          };
        }
        // Si la cabecera actual reporta un derecho mayor, asumimos que es el valor de referencia de este periodo
        if (item.VctDays > grouped[period].VctDays) {
          grouped[period].VctDays = item.VctDays;
        }
        if ((item.VctSoldDays || 0) > grouped[period].VctSoldDays) {
          grouped[period].VctSoldDays = item.VctSoldDays || 0;
        }
        if ((item.VctAccumulatedDays || 0) > grouped[period].VctAccumulatedDays) {
          grouped[period].VctAccumulatedDays = item.VctAccumulatedDays || 0;
        }
        if ((item.VctTransferredDays || 0) > grouped[period].VctTransferredDays) {
          grouped[period].VctTransferredDays = item.VctTransferredDays || 0;
        }
        if (item.VctIsAccumulated) {
          grouped[period].VctIsAccumulated = true;
        }
        if (item.VctAccumulatedFromPeriod) {
          grouped[period].VctAccumulatedFromPeriod = item.VctAccumulatedFromPeriod;
        }
        if (item.VctAccumulatedToPeriod) {
          grouped[period].VctAccumulatedToPeriod = item.VctAccumulatedToPeriod;
        }
      });

      // Paso 2: Distribuir los detalles reales
      items.forEach(item => {
        const period = item.VctPeriod;
        if (item.VcdID) { // Solo si es un detalle real
          grouped[period].rows.push(item);
          grouped[period].VcdDays += item.VcdDays || 0;
        }
      });

      // Paso 3: Consolidar y acumular
      Object.entries(grouped).forEach(([period, group]) => {
        result.push(...group.rows);
        result.push({
          __isGroup: true,
          VctPeriod: period,
          VctObservation: group.VctObservation,
          VctDays: group.VctDays,
          VcdDays: group.VcdDays,
          VctSoldDays: group.VctSoldDays,
          VctAccumulatedDays: group.VctAccumulatedDays,
          VctTransferredDays: group.VctTransferredDays,
          VctIsAccumulated: group.VctIsAccumulated,
          VctAccumulatedFromPeriod: group.VctAccumulatedFromPeriod,
          VctAccumulatedToPeriod: group.VctAccumulatedToPeriod
        });

        // Días base reales generados (evita duplicar días trasladados de periodos previos en la suma de derechos)
        const baseDays = Math.max(0, group.VctDays - group.VctAccumulatedDays);
        this.totalVctDays += baseDays;
        this.totalVcdDays += group.VcdDays;
        this.totalVctSoldDays += group.VctSoldDays;
      });

      return result;
    },
    selectedCheckSlot(obj) {
      console.log(obj);
      if (obj !== null) {
        this.selected = [];
        this.selected.push(obj);
      }
    }
  }
}
</script>

<style scoped>
.modern-worker-history {
  padding: 20px;
  /* background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
  border-radius: 10px;
  min-height: 100vh;
}

.header-section {
  margin-bottom: 24px;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 300;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.main-title i {
  font-size: 2.8rem;
}

.theme-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.theme-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.theme-selector {
  min-width: 300px;
}

.color-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.color-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.color-option:hover {
  background: rgba(0, 0, 0, 0.04);
}

.color-option.active {
  background: rgba(25, 118, 210, 0.1);
  border-color: #1976D2;
}

.color-preview {
  display: flex;
  gap: 4px;
}

.color-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.theme-name {
  font-weight: 500;
}

.main-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.search-section {
  padding: 24px;
  border-radius: 16px 16px 0 0;
}

.search-container {
  position: relative;
}

.status-chip {
  font-weight: 500 !important;
}

.worker-info-section {
  padding: 24px;
  background: rgba(255, 255, 255, 0.5);
}

.worker-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
}

.worker-avatar i {
  font-size: 4rem;
}

.worker-name {
  font-size: 1.8rem;
  font-weight: 500;
  margin: 0 0 4px 0;
  color: #2c3e50;
}

.worker-subtitle {
  font-size: 1rem;
  color: #7f8c8d;
  margin: 0;
}

.info-cards {
  margin-bottom: 24px;
}

.info-card {
  padding: 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.info-icon i {
  font-size: 2rem;
}

.info-content {
  flex: 1;
}

.info-label {
  font-size: 0.85rem;
  color: #7f8c8d;
  margin: 0 0 4px 0;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.progress-section {
  margin-top: 24px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
}

.progress-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #2c3e50;
  margin: 0 0 12px 0;
}

.progress-bar {
  border-radius: 20px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.progress-text {
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.table-section {
  padding: 24px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.table-title {
  font-size: 1.4rem;
  font-weight: 500;
  color: #2c3e50;
  margin: 0;
}

.modern-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.modern-table {
  background: rgba(255, 255, 255, 0.9) !important;
}

.group-row {
  font-weight: 600;
}

.group-cell {
  padding: 16px 12px !important;
}

.group-content {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}

.data-row {
  transition: all 0.2s ease;
}

.data-row:hover {
  background: rgba(0, 0, 0, 0.02) !important;
}

.data-row.selected {
  background: rgba(25, 118, 210, 0.08) !important;
}

.days-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.days-badge.corresponds {
  background: #e3f2fd;
  color: #1976d2;
}

.days-badge.enjoyed {
  background: #e8f5e8;
  color: #2e7d32;
}

.date-display {
  font-family: 'Roboto Mono', monospace;
  font-size: 0.9rem;
  padding: 2px 8px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #7f8c8d;
}

.empty-icon i {
  font-size: 5rem;
  margin-bottom: 16px;
}

.empty-state h3 {
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: #2c3e50;
}

.empty-state p {
  font-size: 1rem;
  margin: 0;
}

@media (max-width: 768px) {
  .modern-worker-history {
    padding: 12px;
  }

  .main-title {
    font-size: 2rem;
  }

  .worker-header {
    flex-direction: column;
    text-align: center;
  }

  .table-header {
    flex-direction: column;
    text-align: center;
  }
}
</style>